import moment from 'moment';

import { axios as service } from '../axiosService';
import { BASE_URL } from './index';
import { capitalizeFirstLetter } from '@utils/common';
import { normalizeIntegrationPdfUrl } from '@utils/integrationPdfLink';

export const getProjectsList = () =>
  service.get(`${BASE_URL}/project/list`).then((res) => {
    const { data = [], top } = res || {};

    // let role = 'internal';

    // if (isAdmin) {
    //   role = 'admin';
    // } else if (isClient) {
    //   role = 'client';
    // }

    return { data, top };
  });

export const getProjectsArchive = () =>
  service.get(`${BASE_URL}/project/archivedList`).then((res) => {
    const { data = [] } = res || {};

    return { data };
  });

export const restoreProject = async (projectId) =>
  await service.get(`${BASE_URL}/project/restore/${projectId}`);

export const archiveProject = async (projectId) =>
  await service.get(`${BASE_URL}/project/archive/${projectId}`);

export const createProject = (data) =>
  service.post(`${BASE_URL}/project/create`, data).then((res) => res || null);

export const resendinvite = (data) =>
  service
    .post(`${BASE_URL}/project/resendinvite`, data)
    .then((res) => res || null);

export const getProjectAnalysisOverview = async (projectId) =>
  await service.get(
    `${BASE_URL}/project/companyOverview/${projectId}?needFormat=true`,
  );
export const queryCreateProjectCompanyName = (word, mode = 'name') =>
  // keyword is search value;
  // mode is where the data is searched;  mode:[name,duns,website,confirm-craft,factiva];
  service
    .get(`${BASE_URL}/company?keyword=${word}&mode=${mode}`)
    .then((res) => res || null);

export const queryDUNsNumAndName = (url) =>
  service.get(`${BASE_URL}/company${url}`).then((res) => res || null);

// deprecated, use getTeamsNames in commonService.api.js
export const queryTeamsName = (data) =>
  service
    .get(
      `${BASE_URL}/people/pwc-employee/search?keyword=${data}&whitelist=only`,
    )
    .then((res) => res || null);

export const queryMemberInfoByGuid = (guid) =>
  service
    .get(`${BASE_URL}/people/getUserInfoByGuid/${guid}`)
    .then((res) => res || null);

export const postTeamSetting = (id, data) =>
  service
    .post(`${BASE_URL}/project/teamSetting/${id}`, data)
    .then((res) => res || null);

export const postProjectSetting = (id, data) =>
  service
    .post(`${BASE_URL}/project/settings/${id}`, data)
    .then((res) => res || null);

export const updateIssue = (data) => {
  const formattedData = {
    updates: data,
  };
  return service
    .put(`${BASE_URL}/project/issue`, formattedData)
    .then((res) => res || null);
};

export const getIssueList = (pageIndex = 1) =>
  service
    .get(`${BASE_URL}/project/issue/list?pageSize=10&pageIndex=${pageIndex}`)
    .then((res) => res || null);

export const getAdminList = () =>
  service.get(`${BASE_URL}/project/issue/admin`).then((res) => res || null);

export const deleteProject = (projectId) =>
  service.delete(`${BASE_URL}/project/${projectId}`).then((res) => res || null);

export const pinProjects = (projectIds = []) => {
  const url = `${BASE_URL}/project/pin${
    projectIds.length > 0 ? `?top=${projectIds.join(',')}` : ''
  }`;
  return service.get(url).then((res) => res || null);
};

export const getClientUserPermission = (projectId) => {
  const url = `${BASE_URL}/project/clientPermission/${projectId}`;
  return service.get(url).then((res) => res || null);
};
export const getIntegrationApproach = (projectId) => {
  const url = `${BASE_URL}/project/integrationApproach/${projectId}`;
  return service.get(url).then((res) => res.integrationApproachData || null);
};

export const getSeparationApproach = (projectId) => {
  const url = `${BASE_URL}/project/integrationApproach/${projectId}?type=separation`;
  return service.get(url).then((res) => res.integrationApproachData || null);
};
export const postIntegrationApproach = (projectId, data) => {
  const postData = { integrationApproachData: data };
  const url = `${BASE_URL}/project/integrationApproach/${projectId}`;
  return service.post(url, postData).then((res) => res || null);
};

export const postSeparationApproach = (projectId, data) => {
  const postData = { integrationApproachData: data };
  const url = `${BASE_URL}/project/integrationApproach/${projectId}?type=separation`;
  return service.post(url, postData).then((res) => res || null);
};
export const exportFinancialsData = (projectId) => {
  const url = `${BASE_URL}/project/financials/${projectId}/report`;
  return service.get(url, { responseType: 'blob' }).then((res) => res || null);
};
export const uploadExcel = (projectId, data) => {
  const url = `${BASE_URL}/project/financials/${projectId}/report`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    timeout: 0,
  });
};
export const uploadPdf = (projectId, data) => {
  const url = `${BASE_URL}/project/integrationModuleWithTab/${projectId}/pdf`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
  });
};
export const getPdf = (pdfUrl, projectId) => {
  const pdfPath = normalizeIntegrationPdfUrl(pdfUrl, projectId);
  const url = `${BASE_URL}${pdfPath}`;
  return service.get(url, { responseType: 'blob' });
};

export const uploadReportPdf = (projectId, data) => {
  const url = `${BASE_URL}/project/pdfModule/create/${projectId}`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;' },
  });
};

export const getReportPdf = (pdfId) => {
  const url = `${BASE_URL}/project/pdfModule/${pdfId}`;
  return service.get(url, { responseType: 'blob' });
};

export const editReportPdf = (pdfId, data) => {
  const url = `${BASE_URL}/project/pdfModule/update/${pdfId}`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;' },
  });
};

export const deleteReportPdf = (pdfId) => {
  const url = `${BASE_URL}/project/pdfModule/${pdfId}`;
  return service.delete(url);
};

export const uploadIMG = (data) => {
  const url = `${BASE_URL}/project/imageModule/upload`;
  return service.post(url, data);
};

export const uploadHtml = (data) => {
  const url = `${BASE_URL}/project/html/upload`;
  // HTML upload only: accept all HTTP statuses so validation errors (e.g. message +
  // errors[]) reach the upload UI without the global ApiClientError fallback.
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' },
    skipGlobalErrorHandler: true,
    validateStatus: () => true,
  });
};

export const downloadIMG = (imgPath) => {
  const url = `${BASE_URL}/project/imageModule/download`;
  return service.post(url, JSON.stringify({ fileName: imgPath }), {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
  });
};

export const downloadHtml = (fileName) => {
  const url = `${BASE_URL}/project/html/download`;
  return service.post(url, JSON.stringify({ fileName }), {
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    skipGlobalErrorHandler: true,
    includeResponseHeaders: true,
  });
};

export const updateIMG = (data) => {
  const url = `${BASE_URL}/project/imageModule/update`;
  return service.post(url, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteIMG = (imgPath) => {
  const url = `${BASE_URL}/project/imageModule/delete`;
  return service.post(url, JSON.stringify({ fileName: imgPath }), {
    headers: { 'Content-Type': 'application/json' },
  });
};

export function processRawLifecycleData(data) {
  const today = moment().startOf('d');
  let {
    idLocations,
    idLocationsReset,
    defaultActiveId,
    stepDates,
    defaultSequences,
  } = (data.lifecycleSectionInfo.lifecyclePeriods || []).reduce(
    (result, item = {}, itemIdx) => {
      let { idLocations, stepDates, defaultActiveId, defaultSequences } =
        result;
      const ids = [],
        sequence = defaultSequences[item.id] || [];
      (item.lifecycleItems || []).forEach((node, index) => {
        ids.push([node.id, [itemIdx, index]]);
        sequence.push(index);
      });

      const currentStepDate = item.startAt ? moment(item.startAt) : null;

      if (currentStepDate && currentStepDate.startOf('d') <= today) {
        defaultActiveId = item.id;
      }

      return {
        idLocations: [...idLocations, ...ids, [item.id, [itemIdx]]],
        idLocationsReset: [...idLocations, ...ids, [item.id, [itemIdx]]],
        defaultActiveId,
        stepDates: [...stepDates, currentStepDate],
        defaultSequences: { ...defaultSequences, [item.id]: sequence },
      };
    },
    {
      idLocations: [],
      defaultActiveId: '',
      stepDates: [],
      defaultSequences: {},
    },
  );

  idLocations = new Map(idLocations);
  idLocationsReset = new Map(idLocationsReset);
  return {
    treeData: data.lifecycleSectionInfo.lifecyclePeriods,
    // phaseIds: data.lifecycleSectionInfo.lifecyclePeriods
    //   ?.map((i) => i?.id)
    //   .filter((i) => !!i),
    nodeIds: data.lifecycleSectionInfo.lifecyclePeriods
      ?.map((i) => i?.lifecycleItems?.map((node) => node?.id))
      .flat(1),
    idLocations,
    idLocationsReset,
    treeIds: Array.from(idLocations.keys()),
    defaultActiveId,
    stepDates,
    defaultSequences,
    title: data.lifecycleSectionInfo.sectionTitle,
    section: {
      date: data.lifecycleSectionInfo.sctionDate,
      description: data.lifecycleSectionInfo.description,
    },
  };
}
export const getLifecycleDataRequest = (projectId, type) =>
  service
    .get(
      `${BASE_URL}/project/lifecycle/getLifecycleInfo/${projectId}?type=${capitalizeFirstLetter(
        type,
      )}`,
    )
    .then((data) => data && processRawLifecycleData(data));

export const updateLifecyleDataRequset = (projectId, postBody, type) =>
  service.post(
    `${BASE_URL}/project/lifecycle/saveLifecycleInfo/${projectId}?type=${capitalizeFirstLetter(
      type,
    )}`,
    postBody,
  );

export const getDelligenceHideStatusRequest = (projectId) =>
  service.get(
    `${BASE_URL}/project/lifecycle/getLifecycleHideStatus/${projectId}`,
  );

// hide the first phase of lifecycle
export const saveDelligenceHideStatusRequest = (projectId, postBody) =>
  service.post(
    `${BASE_URL}/project/lifecycle/saveLifecycleHideStatus/${projectId}`,
    postBody,
  );

export const getUploadHistory = (projectId) =>
  service.get(`${BASE_URL}/project/financials/${projectId}/report/history`);

export const downloadWeeklyReport = (dateRange = []) =>
  service.get(
    `${BASE_URL}/report/project-creation-statistics?start=${dateRange[0]}&end=${dateRange[1]}`,
    { responseType: 'blob' },
  );

export const postIntegrationHubModule = (data, projectId) =>
  service
    .post(`${BASE_URL}/project/integrationHubModule/${projectId}`, data)
    .then((res) => res || null);

export const getPowerbiUserguid = (projectId) =>
  service.get(
    `${BASE_URL}/project/userGuide/getPDFByType?pdfType=Integration Hub User Guide`,
    {
      responseType: 'blob',
    },
  );

export const getCustomizedModule = (id) => {
  if (!id || id === 'null') {
    return null;
  }
  return service.get(`${BASE_URL}/project/customizeModule/${id}`);
};

export const getProjectMember = (id) => {
  if (!id || id === 'null') {
    return null;
  }
  return service.get(`${BASE_URL}/people/getProjectMember/${id}`);
};

export const getProjectAccessibleModules = (projectId) => {
  if (!projectId || projectId === 'null') {
    return null;
  }
  return service.get(`${BASE_URL}/project/accessibleModule/${projectId}`);
};

export const getCustomizedWidget = (widgetId) => {
  if (!widgetId) {
    return null;
  }
  return service.get(`${BASE_URL}/project/customizeChart/${widgetId}`);
};

export const getInsightsChart = (projectId, type) => {
  if (!projectId || !type) {
    return null;
  }
  return service.get(`${BASE_URL}/project/insightChart/${projectId}/${type}`);
};

export const saveCustomzizedWidget = (projectId, widgetId, data) => {
  if (!projectId) {
    return null;
  }
  if (widgetId) {
    return service.post(`${BASE_URL}/project/customizeChart/${projectId}`, {
      id: widgetId,
      ...data,
    });
  }
  return service.post(
    `${BASE_URL}/project/customizeChart/${projectId}`,
    {
      ...data,
    },
    // tag insights chart for purge in redis;
    data?.moduleType === 'insights'
      ? { params: { moduleType: data.moduleType } }
      : undefined,
  );
};

export const getChartTemplate = () =>
  service.get(`${BASE_URL}/project/chartTemplate`);

export const saveChartTemplate = (data) =>
  service.post(`${BASE_URL}/project/chartTemplate`, data);

export const getTextContainer = (id) => {
  if (!id) {
    return null;
  }
  return service.get(`${BASE_URL}/project/textContainer/${id}`);
};

export const saveTextContainer = (data) =>
  service.post(`${BASE_URL}/project/textContainer`, data);

export const getTextContainerTemplate = (id) => {
  if (!id) {
    return null;
  }
  return service.get(`${BASE_URL}/project/textContainerTemplate/${id}`);
};

export const saveTextContainerTemplate = (data) =>
  service.post(`${BASE_URL}/project/textContainerTemplate`, data);

export const createWorkSpace = (id) =>
  service.post(`${BASE_URL}/sharepoint/createGroup/${id}`);

export const getExecutiveSummaryField = (id) =>
  service.get(`/api/v1/project/executiveOverviewField/${id}`);

export const getExecutiveSummaryData = (id) =>
  service.get(`/api/v1/project/executiveOverviewValue/${id}`);

export const setExecutiveSummaryField = (id, fields) =>
  service.post(`/api/v1/project/executiveOverviewField/${id}`, {
    fieldConfig: fields,
  });

export const setExecutiveSummaryValue = (id, rows) =>
  service.post(`/api/v1/project/executiveOverviewValue/${id}`, {
    executiveOverviewData: rows,
  });

export const refreshPBIDataset = (projectId, data) =>
  service.post(`${BASE_URL}/project/refreshPBIDataset/${projectId}`, data);

export const validateClientEmails = async ({ emails }) => {
  const response = await service.post(`${BASE_URL}/project/checkDomain`, {
    emails,
  });
  return response;
};

export const checkProfileStatus = async () => {
  try {
    const response = await service.get(`${BASE_URL}/people/getProfileStatus`);
    console.log('checkProfileStatus API response:', response);
    return response;
  } catch (error) {
    console.error('checkProfileStatus API error:', error);
    throw error;
  }
};

export const updateUserName = async (data) => {
  try {
    const response = await service.put(
      `${BASE_URL}/people/updateUserName`,
      data,
    );
    console.log('update profile : ', response);
    return response;
  } catch (error) {
    console.error('Update user name API error:', error);
    throw error;
  }
};
